import type { SetlistContext } from './client';
import { getContributorSlugsByNames } from './get-contributor-slugs-by-names';

// Single-name convenience over the batched lookup: same query shape,
// observability, and slug-fallback behaviour. The batched form is the
// source of truth — see get-contributor-slugs-by-names.ts.
export const getContributorSlugByName = async (
  context: SetlistContext,
  name: string
): Promise<string | null> => {
  const trimmed = name.trim();
  if (!trimmed) {
    return null;
  }

  const map = await getContributorSlugsByNames(context, [trimmed]);
  // Prefer an exact key match — Typesense filter matching is
  // case-insensitive but the indexer's stored name may differ in casing
  // from the input. Fall back to the first map entry since the filter
  // targets a single name, so the map holds at most one entry.
  if (map[trimmed]) {
    return map[trimmed];
  }
  const [firstKey] = Object.keys(map);
  return firstKey ? (map[firstKey] ?? null) : null;
};
